import React, { useEffect } from "react";
import Header from "../Header/Header";
import Main from "../Main/Main";
import Footer from "../Footer/Footer";
import PortfolioPageTitle from "./PortfolioPageTitle";
import PortfolioSection from "./PortfolioSection";
import "../../../assets/website/css/main2.css";
import ScrollTop from "../BackToTop";
import { useTranslation } from "react-i18next";

function Portfolio() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = t("portfolio");
  }, [t]);

  return (
    <>
      <Header />
      <Main>
        <PortfolioPageTitle />

        <PortfolioSection />
      </Main>
      <Footer />
      {/* <ScrollTop /> */}
    </>
  );
}

export default Portfolio;
